import { useParentOffice } from '~/hooks';
import { useSelectedOffice } from '~/hooks/useSelectedOffice';
import { IUser } from '~/models';
import { TNullable } from '~/types/Nullable';
import { OfficeTypeEnum } from '~/utils/Enum';
import { getCompanyMatchLabel } from '../utils';

interface IUseCompanyMatchLabelPayload {
  offerOwnerId: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
}

export const useCompanyMatchLabel = ({
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
  offerOwnerId,
  professional,
}: IUseCompanyMatchLabelPayload) => {
  const { office } = useParentOffice();

  const offerOwner = useSelectedOffice(offerOwnerId);

  const isDSO = offerOwner.office_info?.officeType === OfficeTypeEnum.DSO;

  return getCompanyMatchLabel({
    averageRating: professional?.average_rating,
    hasBadges: !!professional?.badges?.length || !!professional?.currentRank?.rank,
    hasWorkedWithDSO,
    hasWorkedWithOffice,
    isDSO,
    officeName: isDSO ? office?.dsoFullName : offerOwner.office_name,
  });
};
